<fieldset class="p-0">
  <label *ngIf="showLabel">{{ label | translate }}</label>

  <div class="chip-editor" [class.disabled]="disableInput">
    <ng-container *ngFor="let v of values; trackBy: trackByValueId">
      <span class="chip" *ngIf="v.value && v.value.trim()">
        <span class="chip-text">{{ v.value }}</span>
        <button type="button" class="chip-x" (click)="remove(v)" [disabled]="disableInput"
          tabindex="-1" [attr.aria-label]="'ac_delete' | translate">
          <i class="bi bi-x-lg"></i>
        </button>
      </span>
    </ng-container>

    <input class="chip-input" type="text" [(ngModel)]="draft" [disabled]="disableInput"
      (keydown)="onKeydown($event)" (blur)="onBlur()" (paste)="onPaste($event)"
      [placeholder]="values.length ? ('pv_add_more' | translate) : placeholder" />

    <button type="button" class="chip-add-btn" [class.ready]="canAdd" [disabled]="!canAdd"
      (click)="commitDraft()">
      <i class="bi bi-plus-lg"></i><span>{{ 'ac_add' | translate }}</span>
    </button>
  </div>
</fieldset>
